"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultType = void 0;
var SearchResultType;
(function (SearchResultType) {
    SearchResultType["Label"] = "label";
    SearchResultType["Node"] = "node";
    SearchResultType["Resource"] = "resource";
    SearchResultType["Note"] = "note";
    SearchResultType["Domain"] = "domain";
})(SearchResultType = exports.SearchResultType || (exports.SearchResultType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VhcmNoLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3B1YmxpYy9pbnRlcmZhY2VzL1NlYXJjaC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFNQSxJQUFZLGdCQU1YO0FBTkQsV0FBWSxnQkFBZ0I7SUFDMUIsbUNBQWUsQ0FBQTtJQUNmLGlDQUFhLENBQUE7SUFDYix5Q0FBcUIsQ0FBQTtJQUNyQixpQ0FBYSxDQUFBO0lBQ2IscUNBQWlCLENBQUE7QUFDbkIsQ0FBQyxFQU5XLGdCQUFnQixHQUFoQix3QkFBZ0IsS0FBaEIsd0JBQWdCLFFBTTNCIn0=